import { matchPath } from 'react-router-dom';

const isLoadableComponent = (Component) => Component.load !== undefined;

export const loadAllComponents = async (routes, pathname) =>
  await Promise.all(
    routes.map((route) => {
      const match = matchPath(pathname || window.location.pathname, route);
      if (match && route.component && isLoadableComponent(route.component)) {
        return route.component.load();
      }
    })
  );

/**
 * This helps us to make sure all the async code is loaded before rendering.
 */
export const ensureReady = async (routes, pathname) => {
  await loadAllComponents(routes, pathname);

  if (typeof window !== undefined && !!document) {
    // deserialize state from 'serialize-javascript' format
    return eval(
      '(' + document.getElementById('server-app-state').textContent + ')'
    );
  }
};
